// extracted by mini-css-extract-plugin
export default {"items":"CartItem_items__YfZnR","itemsPrice":"CartItem_itemsPrice__z2icE","info":"CartItem_info__5C1gL","remove":"CartItem_remove__PVLsN"};